export type ChatDesktopMode = 'page' | ChatOffRouteMode;
export type ChatOffRouteMode = 'panel' | 'minimized' | 'closed';
export type ChatMobileView = 'conversation' | 'conversationList';

export type ChatPresentationAction =
  | { type: 'open-panel' }
  | { type: 'minimize' }
  | { type: 'restore' }
  | { type: 'close' };

export const INITIAL_CHAT_OFF_ROUTE_MODE: ChatOffRouteMode = 'closed';

export const reduceChatPresentation = (
  state: ChatOffRouteMode,
  action: ChatPresentationAction
): ChatOffRouteMode => {
  switch (action.type) {
    case 'open-panel':
    case 'restore':
      return 'panel';
    case 'minimize':
      return state === 'closed' ? state : 'minimized';
    case 'close':
      return 'closed';
    default:
      return state;
  }
};
